import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectListItems } from "../../../../../redux/library/selector";
import { selectOrdersListItems } from "../../../../../redux/orders/selector";
import { orders } from "../../../../../redux/orders/action";
import { settings } from "../../../../../redux/settings/actions";
import GetQuote from "../../../../../models/GetQuote";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const ManagementOrders = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectOrdersListItems)
  const [pageSize, setPageSize] = useState(10);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'MobilityOrderPId', headerName: 'Order PId', sortable: true, filter: true, searchField: 'MobilityOrderPId', filterType: 'text' },
      { field: 'MobilityProductName', headerName: 'Product Name' },
      { field: 'OrderTotal', headerName: 'OrderTotal', isCurrencyValueFormat: true, },
      { field: 'InvoiceNumber', headerName: 'Invoice Number', sortable: true, filter: true, },
      { field: 'PickupCode', headerName: 'PickupCode', sortable: true, filter: true, },
      { field: 'RAPName', headerName: 'RAP Name' },
      { field: 'RAPAgentName', headerName: 'RAPAgent Name' },
      { field: 'RAPCustomerName', headerName: 'Customer Name' },
      { field: 'MobilityOrderNotes', headerName: 'MobilityOrder Notes', sortable: false, filter: true },
      { field: 'MobilityOrderStatusId', headerName: 'Order Status', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.MobilityOrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' } },
      // {
      //   field: 'Repeat Order',
      //   headerName: 'Repeat Order',
      //   cellRenderer: 'buttonRenderer',
      //   buttonName: 'Repeat order',
      // },
      // { field: 'Download Invoice', headerName: 'Download Invoice',PDFName: 'Download Invoice',isPrintandDownloadPDF:true },
      { field: 'ScheduledDate', headerName: 'Scheduled Date', isDateValueFormat: true, },
      { field: 'CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true, },

    ]);
  }
  const handleEdit = (data: any) => {

    navigate(`${data?.MobilityOrderId}`)
  }

  const handleDelete = async (data: any) => {
    await dispatch(orders.delete({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/orders/delete`,
      entity: 'orders',
      jsonData:
      {
        "Context": {},
        "Records": [
          {
            "Id": data?.MobilityOrderId
          }
        ]
      }
    }))
    await fetchOrders()
  }

  const handleReloadData = () => {
    fetchOrders()
  }

  const fetchOrders = async () => {
    await dispatch(orders.resetAction({ actionType: 'list' }))
    await dispatch(orders.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/orders/fetch`, entity: 'order',
      jsonData:
      {
        "Context": {},
        "Records": [{}],
        "Pagination": {
           "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "CreatedOnUtc",
          "SortOrder": "desc",
        }
      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchOrders()
  }, [pageData, pageSize])

  const handleAdd = () => {
    dispatch(settings.set({ getQuote: 'open' }))
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Create Order</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    }
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "MobilityOrderPId",
        FieldText: "MobilityOrderPId",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/orders/fetch`, entity: 'orders',
      jsonData:
      {
        "Context": {},
        "Records": [{}],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "CreatedOnUtc",
          "SortOrder": "desc",
          "isOrCondition": true,
          "isFilterConditionOr": true,
          "isSearchConditionOr": true,
          "Searches": searchCriteria,

        }
      }
    }
    ));
  }
  return (
    <>
      <GetQuote />

      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          onSearch={handleSearch}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          additionButtons={additionButtons}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          headingName="Orders" />
      }
    </>

  );
};

export default ManagementOrders;


